export default __webpack_public_path__ + "static/media/menu.39904ef9.png";